export const DEALER_BRANDS = [
  'volkswagen',
  'audi',
  'seat',
  'skoda',
  'cupra',
  'volkswagen vic',
  'honda',
  'nissan',
  'fiat',
  'alfa romeo',
  'lancia',
  'jeep',
  'abarth',
  'fiat pro',
  'citroen',
  'peugeot',
  'opel',
  'ds',
  'dongfeng',
  'xpeng',
  'renault',
  'dacia',
  'alpine',
  'byd',
  'omoda',
  'jaecoo',
  'geely'
];
